import React from 'react';
import { components } from '../utils/designTokens';

/**
 * ViewTabs - Navigation tabs for switching between related entity views
 * Used for switching between different entity types (e.g., Agents/Tools/Models)
 */
const ViewTabs = ({ tabs, activeTab, onTabChange }) => {
  if (!tabs || !Array.isArray(tabs) || tabs.length === 0) {
    throw new Error('ViewTabs requires tabs array with at least one tab');
  }
  if (!activeTab) throw new Error('ViewTabs requires activeTab prop');
  if (!onTabChange) throw new Error('ViewTabs requires onTabChange prop');

  return (
    <div className="flex gap-2">
      {tabs.map((tab) => {
        const isActive = tab.value === activeTab;
        return (
          <button
            key={tab.value}
            onClick={() => onTabChange(tab.value)}
            className={`px-2.5 py-1 rounded-full text-sm font-medium transition-colors ${
              isActive
                ? 'bg-accent-primary-base text-text-inverse'
                : 'bg-background-tertiary text-text-supporting hover:bg-background-quaternary'
            }`}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
};

export default ViewTabs;
